{
  "level": "bs0206mv",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:bs0206mv",
    "objects": "AREAS.E3:bs0206mv.e3",
    "mesh": "TREES.E3:bs0206mv.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 1.0,
      "bbox_min": [
        -10.0,
        -10.0,
        -1.0
      ],
      "bbox_max": [
        10.0,
        10.0,
        -1.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: door11",
      "entity_class": "CSlidingDoor",
      "piece_name": "door11",
      "offset": 445,
      "centroid": [
        -3097.5001831054688,
        -4411.41845703125,
        1044.3118896484375
      ],
      "bbox_min": [
        -3102.499755859375,
        -4412.068359375,
        1038.623779296875
      ],
      "bbox_max": [
        -3092.499755859375,
        -4410.7685546875,
        1050.0
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 1.2998046875,
        "height_z": 11.376220703125,
        "door_width": 10.0,
        "door_depth": 1.2998046875,
        "leaf_depth": 1.2598046875,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3092.499755859375,
          -4410.7685546875,
          1038.623779296875
        ],
        [
          -3102.499755859375,
          -4410.7685546875,
          1038.623779296875
        ],
        [
          -3092.50146484375,
          -4410.7685546875,
          1050.0
        ],
        [
          -3102.499755859375,
          -4410.7685546875,
          1050.0
        ],
        [
          -3092.50146484375,
          -4412.068359375,
          1050.0
        ],
        [
          -3092.499755859375,
          -4412.068359375,
          1038.623779296875
        ],
        [
          -3102.499755859375,
          -4412.068359375,
          1038.623779296875
        ],
        [
          -3102.499755859375,
          -4412.068359375,
          1050.0
        ]
      ],
      "plane_distance": 4410.7686,
      "authentic_texture": "doorjam"
    }
  ],
  "tutorial_messages": []
}